export enum FarmCsrFileType {
  SOIL_TEST = 'soil test',
  CERTIFICATION = 'certification',
  TRAINING = 'training',
  OTHER = 'other',
}
